document.addEventListener('alpine:init', () => {
  function productFormActions(data = {}) {
    return {
      ...data,

      onIntersectEnterActions() {
        this.$dispatch('productformactionsintersectenter');
      },

      onIntersectLeaveActions() {
        this.$dispatch('productformactionsintersectleave');
      },
    };
  };

  Alpine.data('productFormActions', productFormActions);
});
